import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EOfferSource;
(function (EOfferSource) {
  EOfferSource["Cancellation"] = "cancellation";
  EOfferSource["Manual"] = "manual";
  EOfferSource["FindOpenSpots"] = "find-open-spots";
  EOfferSource["SelfScheduling"] = "self-scheduling";
  EOfferSource["Reschedule"] = "reschedule";
  EOfferSource["StaffScheduling"] = "staff-scheduling";
  EOfferSource["RescheduleFromIntent"] = "reschedule-from-intent";
})(EOfferSource || (EOfferSource = {}));
export let EOfferStatus;
(function (EOfferStatus) {
  EOfferStatus["InProgress"] = "in-progress";
  EOfferStatus["PatientFound"] = "patient-found";
  EOfferStatus["PatientNotFound"] = "patient-not-found";
  EOfferStatus["Cancelled"] = "cancelled";
})(EOfferStatus || (EOfferStatus = {}));
export let EOfferProtocol;
(function (EOfferProtocol) {
  EOfferProtocol["Serial"] = "serial";
  EOfferProtocol["Parallel"] = "parallel";
})(EOfferProtocol || (EOfferProtocol = {}));
export let EOfferIntegratorCreationStatus;
(function (EOfferIntegratorCreationStatus) {
  EOfferIntegratorCreationStatus["Success"] = "success";
  EOfferIntegratorCreationStatus["Failure"] = "failure";
  EOfferIntegratorCreationStatus["Pending"] = "pending";
})(EOfferIntegratorCreationStatus || (EOfferIntegratorCreationStatus = {}));
export const fieldsOffer = _extends({}, fieldsIBaseModel, {
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType,
    array: true
  },
  approvedBy: {
    type: 'ID',
    ref: EModel.User
  },
  availability: {
    type: 'ID',
    ref: EModel.Availability
  },
  currentWaitlist: {
    type: 'Number'
  },
  date: {
    type: 'Date'
  },
  declinedBy: {
    type: 'ID',
    ref: EModel.User
  },
  duration: {
    type: 'Number'
  },
  estimatedCompletionAt: {
    type: 'Date'
  },
  expireAt: {
    type: 'Date'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  integratorCreationResults: {
    type: 'Object'
  },
  offer: {
    type: 'ID',
    ref: EModel.Offer
  },
  patientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  patientFormTemplate: {
    type: 'ID',
    ref: EModel.PatientFormTemplate
  },
  patientFound: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientFoundAt: {
    type: 'Date'
  },
  protocol: {
    type: 'Option',
    values: EOfferProtocol
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  referral: {
    type: 'ID',
    ref: EModel.Referral
  },
  rescheduledFromAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  shadowAppointment: {
    type: 'Text'
  },
  source: {
    type: 'Option',
    values: EOfferSource
  },
  status: {
    type: 'Option',
    values: EOfferStatus
  },
  usedForAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  waitlists: {
    type: 'ID',
    ref: EModel.Waitlist,
    array: true
  }
});